import React from "react";
import withProviders from "../../hooks/withProviders";
import ProvidersManagement from "../../features/providersmanagement";
import { FilterProvider, ProviderDefaultFilters } from "../../hooks/FilterContext";

const AssetsProvidersManagementPage = () => <ProvidersManagement />

export default withProviders([FilterProvider, { defaultFilters: ProviderDefaultFilters }])(AssetsProvidersManagementPage);